import { unique } from "radash";
import { ContributorRoleCode } from "../../../../../../../searchAndCollection/cordata/roles";
import { SiteSearchConfig } from "../../../../../../../searchAndCollection/searchApi/searchConfig";
import { WorkSearchResult, searchWorks } from "../../../../../../../searchAndCollection/searchApi/searchWorks";

export type WorksData = { works: WorkSearchResult[]; endOfResults: boolean; isValidating: boolean };

type AgentWorksDataForContributorRoles = Record<ContributorRoleCode, WorksData> | undefined;

export type AgentWorksData = {
  worksDataAboutAgent: WorksData;
  worksDataForContributorRoles: AgentWorksDataForContributorRoles;
};

type FetchInitialAgentWorksDataProps = {
  agentId: string;
  roleCodes: string[];
  searchConfig: SiteSearchConfig;
};

export const fetchInitialAgentWorksData = async ({
  agentId,
  roleCodes,
  searchConfig,
}: FetchInitialAgentWorksDataProps): Promise<AgentWorksData> => {
  const uniqueRoleCodes = unique(roleCodes);
  const [worksDataAboutAgent, worksDataForContributorRoles] = await Promise.all([
    { ...(await fetchAgentWorksDataAboutAgent({ agentId, page: 1, searchConfig })), isValidating: false },
    await fetchAgentWorksDataForContributorRoles(uniqueRoleCodes, agentId, searchConfig),
  ]);
  return { worksDataAboutAgent, worksDataForContributorRoles };
};

export type FetchAgentWorksProps = { agentId: string; page: number; searchConfig: SiteSearchConfig };

export const fetchAgentWorksDataAboutAgent = ({ agentId, page, searchConfig }: FetchAgentWorksProps) => {
  return searchWorks(searchConfig, {
    filter: { "plas.subjects": [agentId] },
    page,
    size: 9,
  });
};

const fetchAgentWorksDataForContributorRoles = (roleCodes: string[], agentId: string, searchConfig: SiteSearchConfig) =>
  roleCodes.length
    ? roleCodes.reduce(
        async (acc, roleCode) => ({
          ...(await acc),
          ...{
            [roleCode]: {
              ...(await fetchAgentWorksDataForContributorRole({ agentId, roleCode, page: 1, searchConfig })),
              isValidating: false,
            },
          },
        }),
        Promise.resolve({} as AgentWorksDataForContributorRoles)
      )
    : undefined;

export const fetchAgentWorksDataForContributorRole = ({
  agentId,
  page,
  searchConfig,
  roleCode,
}: FetchAgentWorksProps & { roleCode: string }) => {
  return searchWorks(searchConfig, {
    filter: { ["bmdb.contributor"]: [`${agentId}/role=${roleCode}`] },
    page,
    size: 9,
  });
};
